  <div class="w-full" [ngClass]="scrollWithMainScrollbar ? 'flex flex-col' : 'block'">
    @defer() {
      @if (enableVirtualScroll) {
        <!-- template con o senza ngx-scrollbar, nel caso il viewport sia la mainScrollbar-->
        @if (wrapInScrollbar) {
          <ng-scrollbar #vsScrollbar externalViewport=".v-scroller" style="height: 100%" externalSpacer=".total-padding" asyncDetection
            appearance="compact"
            [orientation]="horizontal ? 'horizontal' : 'vertical'"
            visibility="hover">
            <virtual-scroller
              class="v-scroller"
              scrollViewport
              [@listStagger]="enterAnim"
              [executeRefreshOutsideAngularZone]="false"
              [scrollThrottlingTime]="50"
              [enableUnequalChildrenSizes]="enableUnequalChildrenSizes"
              (vsUpdate)="updateScrollbar(vsScrollbar);"
              #scroll [items]="items()"
              (vsEnd)="fetchMore($event)"
              [parentScroll]="null"
              [class.visible]="isRendered || (isEmpty && emptyTpl)"
              [horizontal]="horizontal"
              [childHeight]="itemHeight"
              [childWidth]="itemWidth">
              @for (item of scroll.viewPortItems; track trackByFn($index, item)) {
                <ng-container
                  *ngTemplateOutlet="itemTpl; context: {$implicit: item}">
                </ng-container>
              }
              @if (isEmpty && emptyTpl) {
                <ng-container *ngTemplateOutlet="emptyTpl"></ng-container>
              }
            </virtual-scroller>
          </ng-scrollbar>
        } @else {
          <virtual-scroller
            [@listStagger]="enterAnim"
            (@listStagger.done)="refreshVsMeasurements($event)"
            [executeRefreshOutsideAngularZone]="false"
            [scrollThrottlingTime]="200"
            [enableUnequalChildrenSizes]="enableUnequalChildrenSizes"
            (vsScrollLenghtChange)="updateContainer($event)"
            #scroll [items]="items()"
            (vsEnd)="fetchMore($event)"
            [parentScroll]="parentScroll"
            [class.visible]="isRendered"
            [horizontal]="horizontal"
            [childHeight]="itemHeight"
            [childWidth]="itemWidth">
            <div #container class="ct">
              @for (item of scroll.viewPortItems; track trackByFn($index, item)) {
                <ng-container
                  *ngTemplateOutlet="itemTpl; context: {$implicit: item}">
                </ng-container>
              }
              <ng-container *ngTemplateOutlet="juiceLink"></ng-container>
            </div>
          </virtual-scroller>
          @if (scrollWithMainScrollbar) {
            <div #spacer class="spacer"></div>
          }
        }
      
    }
   } @placeholder(minimum 500ms) {
      @if(!platform.isBrowser || !scaleUpOnRender) {
        <div class="h-full w-full relative visible scrollable-content" [ngClass]="horizontal ? 'overflow-hidden' : ''">
          <div #container class="ct absolute left-0 top-0 w-full">
            @for (item of items(); track $index) {
              <ng-container *ngTemplateOutlet="itemTpl; context: {$implicit: item}"></ng-container>
            }
            <ng-container *ngTemplateOutlet="juiceLink"></ng-container>
          </div>
        </div>
      }
  
    }
  
  <ng-template #juiceLink>
    @if (seoFriendly && renderSeoLink()) {
      <a id="seoFriendly" class="hidden" [routerLink]="['./']"
      [queryParams]="{after: seoFriendly ==='offset-cursor' ? offsetCursor:  page.pageInfo.endCursor}" i18n>Next</a>
    }
  </ng-template>
</div>

